import React from 'react';
import { FaSlackHash } from 'react-icons/fa';

function NotFound() {
    return (
        <div style={{textAlign: "center"}}>
            <h1><FaSlackHash /> 404 Not Found</h1>
        </div>
    );
};

export default NotFound;